import React from "react";
import {
  useOrderStatus,
  useProductOrderStatuses,
} from "../../../../api/order-management/use-order-status";
import { useSetState } from "../../../../utils/hooks";
import { OrderTable } from "../order-table";
import OrderCancellationInfo from "./Section/OrderCancellationInfo";

const radioOptionsTab2 = [
  "전체",
  "취소요청",
  "주문취소(미입금)",
  "주문취소(신용카드)",
];

const radioOptions2Tab2 = ["주문취소(무통장입금)"];

export const OrderCancellation = () => {
  const [filter, dispatchFilter] = useSetState();
  const { data } = useProductOrderStatuses();
  const { isEmpty, getDataTableProps } = useOrderStatus(filter, "CANCELED");

  const cancelationRefundData = data?.data?.cancelationRefund;
  return (
    <>
      <OrderCancellationInfo
        cancelationRefundData={cancelationRefundData}
        topTableTitle={`주문 취소 정보`}
        radioOptions={radioOptionsTab2}
        radioOptions2={radioOptions2Tab2}
        tableHead1={
          <div>
            주문취소
            <br />
            (미입금)
          </div>
        }
        tableHead2={
          <div>
            주문취소
            <br />
            (신용카드)
          </div>
        }
        tableHead3={
          <div>
            주문취소
            <br />
            (무통장입금)
          </div>
        }
      />
      <OrderTable isEmpty={isEmpty} getDataTableProps={getDataTableProps} />
    </>
  );
};
